//import $ from 'jquery';
//import * as Validator from 'validatorjs';

const getRandomKey = function(){
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + Math.random().toString(36).substr(2, 9);
};

const getUA = function(){
  
  let _ua = navigator.userAgent.toLowerCase();
  let _o = {
    ltIE6:typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
    ltIE7:typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
    ltIE8:typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
    IE9: navigator.appVersion.toLowerCase().indexOf("msie 9.") != -1,
    IE10 : navigator.userAgent.match(/Trident\/[6]/i),
    IE11: navigator.userAgent.match(/Trident\/7\./),
    IE:document.uniqueID,
    Firefox:window.sidebar,
    Opera:window.opera,
    chrome: _ua.indexOf('chrome') > -1,
		safari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
    //Webkit:!document.uniqueID && !window.opera && !window.sidebar && !window.orientation && window.localStorage,
    mobile:/android|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
    iphone:/iphone|ipod/i.test(_ua),
    android:/android/.test(_ua),
    ipad:/ipad/.test(_ua),
    tablet:undefined,
    smartphone:undefined,
    touch: window.ontouchstart === null
  }
  _o.tablet = _o.ipad;
  if(!_o.tablet && _o.android){ _o.tablet = !(/mobile/.test(_ua));}				
  _o.smartphone = _o.iphone || _o.android ? true : false;
  
  let v = [];
  if (/iP(hone|od|ad)/.test(navigator.platform)) {v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);}
  let vAry = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  _o.iosV = vAry[0] ? vAry[0] : '';

  return _o;
  
}


// const lockBG = {
// 	locked : false,
// 	scrollOffsetY : 0,
// 	toggle : function(){
// 		if(this.locked){
// 			this.unlock();
// 		} else {
// 			this.lock();
// 		}
// 	},
// 	lock : function(){
// 		this.scrollOffsetY = $(window).scrollTop();
// 		$('body').css({position: 'fixed', top: -this.scrollOffsetY, width: '100%'});	
// 		this.locked = true;	
// 	},
// 	unlock : function(){
// 		$('body').css({position: 'static', top: 'auto'});		
// 		window.scrollTo(0, this.scrollOffsetY);	
// 		this.locked = false;	
// 	}		
// }

// const siteNav = {
// 	opened : false,
// 	init: function(){
// 		$('.toggle-nav-button').on('click', (e)=>{
// 			this.toggle();	
// 		});
// 	},
// 	toggle : function(){
// 		if(this.opened){
// 			this.close();
// 		} else {
// 			this.open();
// 		}
// 	},
// 	close : function(){
//     $('.toggle-nav-button').removeClass('opened');
//     $('.site-nav--mobile').removeClass('visible');
// 		$('.site-header').removeClass('site-header--not-transparent');
// 		this.opened = false;

// 		const cartState = store.getters['Cart/cartState'];
// 		if(cartState.visible == false){
// 			lockBG.unlock(); 
// 		}

// 		//lockBG.unlock();
// 	},
// 	open : function(){
//     $('.toggle-nav-button').addClass('opened');
//     $('.site-nav--mobile').addClass('visible');
// 		$('.site-header').addClass('site-header--not-transparent');
// 		this.opened = true;
// 		lockBG.lock();
// 	}		
// }



// const validation = (param, rules)=>{
//   let res = {};

// 	let errorMessages = {};

// 	if(window.theme.locale == 'ja'){
// 		errorMessages = {
// 			required: ':attributeを入力してください。',
// 			"required.contact[title]" : ':attributeを選択してください。',
//       accepted: ':attributeに同意してください。',
// 			email: 'メールアドレスの形式が正しくありません。',
// 			max: ':attributeは:max 文字以内で入力してください。'
// 		}
// 	}
//   let validation = new Validator(param, rules, errorMessages);

// 	//console.log(validation);

//   if (validation.fails()) {
//     res.result = false;
// 		res.errors = validation.errors.all();
// 		return res;
//   } else {
//     res.result = true;
//     return(res);
//   }
// }





class colorSwatchScroller {

	currentX = 0;
  pageNum = 0;
	currentPageNum = 0;
	scroller = null;
	nextBtn = null;
	prevBtn = null;

	constructor (options = {}) {


		this.scroller = options.element;

		this.scroller.addClass('visible')
		this.pageNum = Math.ceil(this.scroller.find('.color-swatch__items').innerWidth() / 200);

		this.nextBtn = this.scroller.find('.color-swatch__scroller-button--next');
		this.prevBtn = this.scroller.find('.color-swatch__scroller-button--prev');
		
		if(this.pageNum == 1){
			this.nextBtn.hide();
		}
		
		this.scroller.removeClass('visible');
		this.nextBtn.on('click', ()=>{
			let index = this.currentPageNum + 1;
			this.currentPageNum = Math.min(index, this.pageNum-1);
			this.scroller.find('.color-swatch__items').css({transform: 'translateX(-'+ (205 * this.currentPageNum) +'px)'});
			if(this.currentPageNum == this.pageNum-1){
				this.nextBtn.hide();
				this.prevBtn.show();
			}
		});

		this.prevBtn.on('click', ()=>{
			let index = this.currentPageNum - 1;
			this.currentPageNum = Math.max(index, 0);
			this.scroller.find('.color-swatch__items').css({transform: 'translateX(-'+ (205 * this.currentPageNum) +'px)'});
			if(this.currentPageNum == 0){
				this.nextBtn.show();
				this.prevBtn.hide();
			}
		});


	}

	setContents(data, param){
		let obj = param;
		this.options = $.extend({}, this.optionsDefault, obj);
		
		if(data)
		this.contents = data;

	}
}




/*
 * BackgroundCheck
 * http://kennethcachia.com/background-check
 *
 * v1.2.2
 */
class BackgroundCheck{

  'use strict';

  resizeEvent = window.orientation !== undefined ? 'orientationchange' : 'resize';
  supported;
  canvas;
  context;
  throttleDelay;
  viewport;
  attrs = {};


  /*
   * Initializer
   */
  constructor(a) {

    if (a === undefined || a.targets === undefined) {
      throw 'Missing attributes';
    }

    // Default values
    this.attrs.debug         = this.checkAttr(a.debug, false);
    this.attrs.debugOverlay  = this.checkAttr(a.debugOverlay, false);
    this.attrs.targets       = this.getElements(a.targets);
    this.attrs.images        = this.getElements(a.images || 'img', true);
    this.attrs.changeParent  = this.checkAttr(a.changeParent, false);
    this.attrs.threshold     = this.checkAttr(a.threshold, 50);
    this.attrs.minComplexity = this.checkAttr(a.minComplexity, 30);
    this.attrs.minOverlap    = this.checkAttr(a.minOverlap, 50);
    this.attrs.windowEvents  = this.checkAttr(a.windowEvents, true);
    this.attrs.maxDuration   = this.checkAttr(a.maxDuration, 500);

    this.attrs.mask = this.checkAttr(a.mask, {
      r: 0,
      g: 255,
      b: 0
    });

    this.attrs.classes = this.checkAttr(a.classes, {
      dark: 'background--dark',
      light: 'background--light',
      complex: 'background--complex'
    });

    if (this.supported === undefined) {
      this.checkSupport();

      if (this.supported) {
        this.canvas.style.position = 'fixed';
        this.canvas.style.top = '0px';
        this.canvas.style.left = '0px';
        this.canvas.style.width = '100%';
        this.canvas.style.height = '100%';

        window.addEventListener(this.resizeEvent, this.throttle(()=>{
          this.resizeCanvas();
          this.check();
        }));

        window.addEventListener('scroll', this.throttle(this.check));

        this.resizeCanvas();
        this.check();
      }
    }
  }


  /*
   * Destructor
   */
  destroy() {
    this.supported = null;
    this.canvas = null;
    this.context = null;
    this.attrs = {};

    if (this.throttleDelay) {
      clearTimeout(this.throttleDelay);
    }
  }


  /*
   * Output debug logs
   */
  log(msg) {

    if (this.get('debug')) {
      console.log(msg);
    }
  }


  /*
   * Get attribute value, use a default
   * when undefined
   */
  checkAttr(value, def) {
    this.checkType(value, typeof def);
    return (value === undefined) ? def : value;
  }


  /*
   * Reject unwanted types
   */
  checkType(value, type) {

    if (value !== undefined && typeof value !== type) {
      throw 'Incorrect attribute type';
    }
  }


  /*
   * Convert elements with background-image
   * to Images
   */
  checkForCSSImages(els) {
    var el;
    var url;
    var list = [];

    for (var e = 0; e < els.length; e++) {
      el = els[e];
      list.push(el);

      if (el.tagName !== 'IMG') {
        url = window.getComputedStyle(el).backgroundImage;

        // Ignore multiple backgrounds
        if (url.split(/,url|, url/).length > 1) {
          throw 'Multiple backgrounds are not this.supported';
        }

        if (url && url !== 'none') {
          list[e] = {
            img: new Image(),
            el: list[e]
          };

          url = url.slice(4, -1);
          url = url.replace(/"/g, '');

          list[e].img.src = url;
					list[e].img.crossOrigin = 'anonymous';
          this.log('CSS Image - ' + url);
        } else {
          throw 'Element is not an <img> but does not have a background-image';
        }
      }
    }

    return list;
  }


  /*
   * Check for String, Element or NodeList
   */
  getElements(selector, convertToImages) {
    var els = selector;

    if (typeof selector === 'string') {
      els = document.querySelectorAll(selector);
    } else if (selector && selector.nodeType === 1) {
      els = [selector];
    }

    if (!els || els.length === 0 || els.length === undefined) {
      throw 'Elements not found';
    } else {

      if (convertToImages) {
        els = this.checkForCSSImages(els);
      }

      els = Array.prototype.slice.call(els);
    }

    return els;
  }


  /*
   * Check if browser supports <canvas>
   */
  checkSupport() {
    this.canvas = document.createElement('canvas');

    if (this.canvas && this.canvas.getContext) {			
      this.context = this.canvas.getContext('2d');
      this.supported = true;
    } else {
      this.supported = false;
    }

    this.showDebugOverlay();
  }


  /*
   * Show <canvas> on top of page
   */
  showDebugOverlay() {

    if (this.get('debugOverlay')) {
      this.canvas.style.opacity = 0.5;
      this.canvas.style.pointerEvents = 'none';
      document.body.appendChild(this.canvas);
    } else {

      // Check if it was previously added
      if (this.canvas.parentNode) {
        this.canvas.parentNode.removeChild(this.canvas);
      }
    }
  }


  /*
   * Stop if it's slow
   */
  kill(start) {
    var duration = new Date().getTime() - start;
    
    this.log('Duration: ' + duration + 'ms');

    if (duration > this.get('maxDuration')) {
      // Log a message even when debug is false
      console.this.log('BackgroundCheck - Killed');
      this.removeClasses();
      this.destroy();
    }
  }


  /*
   * Set width and height of <canvas>
   */
  resizeCanvas() {
    this.viewport = {
      left: 0,
      top: 0,
      right: document.body.clientWidth,
      bottom: window.innerHeight
    };

    this.canvas.width = document.body.clientWidth;
    this.canvas.height = window.innerHeight;
  }


  /*
   * Process px and %, discard anything else
   */
  getValue(css, parent, delta) {
    var value;
    var percentage;

    if (css.indexOf('px') !== -1) {
      value = parseFloat(css);
    } else if (css.indexOf('%') !== -1) {
      value = parseFloat(css);
      percentage = value / 100;
      value = percentage * parent;

      if (delta) {
        value -= delta * percentage;
      }
    } else {
      value = parent;
    }

    return value;
  }


  /*
   * Calculate top, left, width and height
   * using the object's CSS
   */
  calculateAreaFromCSS(obj) {
    var css = window.getComputedStyle(obj.el);

    // Force no-repeat and padding-box
    obj.el.style.backgroundRepeat = 'no-repeat';
    obj.el.style.backgroundOrigin = 'padding-box';

    // Background Size
    var size = css.backgroundSize.split(' ');
    var width = size[0];
    var height = size[1] === undefined ? 'auto' : size[1];

    var parentRatio = obj.el.clientWidth / obj.el.clientHeight;
    var imgRatio = obj.img.naturalWidth / obj.img.naturalHeight;

    if (width === 'cover') {

      if (parentRatio >= imgRatio) {
        width = '100%';
        height = 'auto';
      } else {
        width = 'auto';
        size[0] = 'auto';
        height = '100%';
      }

    } else if (width === 'contain') {

      if (1 / parentRatio < 1 / imgRatio) {
        width = 'auto';
        size[0] = 'auto';
        height = '100%';
      } else {
        width = '100%';
        height = 'auto';
      }
    }

    if (width === 'auto') {
      width = obj.img.naturalWidth;
    } else {
      width = this.getValue(width, obj.el.clientWidth);
    }

    if (height === 'auto') {
      height = (width / obj.img.naturalWidth) * obj.img.naturalHeight;
    } else {
      height = this.getValue(height, obj.el.clientHeight);
    }

    if (size[0] === 'auto' && size[1] !== 'auto') {
      width = (height / obj.img.naturalHeight) * obj.img.naturalWidth;
    }

    var position = css.backgroundPosition;

    // Fix inconsistencies between browsers
    if (position === 'top') {
      position = '50% 0%';
    } else if (position === 'left') {
      position = '0% 50%';
    } else if (position === 'right') {
      position = '100% 50%';
    } else if (position === 'bottom') {
      position = '50% 100%';
    } else if (position === 'center') {
      position = '50% 50%';
    }

    position = position.split(' ');

    var x;
    var y;

    // Two-value syntax vs Four-value syntax
    if (position.length === 4) {
      x = position[1];
      y = position[3];
    } else {
      x = position[0];
      y = position[1];
    }

    // Use a default value
    y = y || '50%';

    // Background Position
    x = this.getValue(x, obj.el.clientWidth, width);
    y = this.getValue(y, obj.el.clientHeight, height);

    // Take care of ex: background-position: right 20px bottom 20px;
    if (position.length === 4) {

      if (position[0] === 'right') {
        x = obj.el.clientWidth - obj.img.naturalWidth - x;
      }

      if (position[2] === 'bottom') {
        y = obj.el.clientHeight - obj.img.naturalHeight - y;
      }
    }

    x += obj.el.getBoundingClientRect().left;
    y += obj.el.getBoundingClientRect().top;

    return {
      left: Math.floor(x),
      right: Math.floor(x + width),
      top: Math.floor(y),
      bottom: Math.floor(y + height),
      width: Math.floor(width),
      height: Math.floor(height)
    };
  }


  /*
   * Get Bounding Client Rect
   */
  getArea(obj) {
    var area;
    var image;
    var parent;

    if (obj.nodeType) {
      var rect = obj.getBoundingClientRect();

      // Clone ClientRect for modification purposes
      area = {
        left: rect.left,
        right: rect.right,
        top: rect.top,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height
      };

      parent = obj.parentNode;
      image = obj;
    } else {
      area = this.calculateAreaFromCSS(obj);
      parent = obj.el;
      image = obj.img;
    }

    parent = parent.getBoundingClientRect();

    area.imageTop = 0;
    area.imageLeft = 0;
    area.imageWidth = image.naturalWidth;
    area.imageHeight = image.naturalHeight;

    var ratio = area.imageHeight / area.height;
    var delta;

    // Stay within the parent's boundary
    if (area.top < parent.top) {
      delta = parent.top - area.top;
      area.imageTop = ratio * delta;
      area.imageHeight -= ratio * delta;
      area.top += delta;
      area.height -= delta;
    }

    if (area.left < parent.left) {
      delta = parent.left - area.left;
      area.imageLeft += ratio * delta;
      area.imageWidth -= ratio * delta;
      area.width -= delta;
      area.left += delta;
    }

    if (area.bottom > parent.bottom) {
      delta = area.bottom - parent.bottom;
      area.imageHeight -= ratio * delta;
      area.height -= delta;
    }

    if (area.right > parent.right) {
      delta = area.right - parent.right;
      area.imageWidth -= ratio * delta;
      area.width -= delta;
    }

    area.imageTop = Math.floor(area.imageTop);
    area.imageLeft = Math.floor(area.imageLeft);
    area.imageHeight = Math.floor(area.imageHeight);
    area.imageWidth = Math.floor(area.imageWidth);

    return area;
  }


  /*
   * Render image on canvas
   */
  drawImage(image) {
    var area = this.getArea(image);

    image = image.nodeType ? image : image.img;

    if (area.imageWidth > 0 && area.imageHeight > 0 && area.width > 0 && area.height > 0) {
      this.context.drawImage(image,
                        area.imageLeft, area.imageTop, area.imageWidth, area.imageHeight,
                        area.left, area.top, area.width, area.height);
    } else {
      this.log('Skipping image - ' + image.src + ' - area too small');
    }
  }


  /*
   * Add/remove classes
   */
  classList(node, name, mode) {
    var className = node.className;

    switch (mode) {
    case 'add':
      className += ' ' + name;
      break;
    case 'remove':
      var pattern = new RegExp('(?:^|\\s)' + name + '(?!\\S)', 'g');
      className = className.replace(pattern, '');
      break;
    }

    node.className = className.trim();
  }


  /*
   * Remove classes from element or
   * their parents, depending on checkParent
   */
  removeClasses(el) {
    var targets = el ? [el] : this.get('targets');
    var target;

    for (var t = 0; t < targets.length; t++) {
      target = targets[t];
      target = this.get('changeParent') ? target.parentNode : target;
      
      this.classList(target, this.get('classes').light, 'remove');
      this.classList(target, this.get('classes').dark, 'remove');
      this.classList(target, this.get('classes').complex, 'remove');
    }
  }


  /*
   * Calculate average pixel brightness of a region 
   * and add 'light' or 'dark' accordingly
   */
  calculatePixelBrightness(target) {
    var dims = target.getBoundingClientRect();
    var brightness;
    var data;
    var pixels = 0;
    var delta;
    var deltaSqr = 0;
    var mean = 0;
    var variance;
    var minOverlap = 0;
    var mask = this.get('mask');

    if (dims.width > 0 && dims.height > 0) {
      this.removeClasses(target);

      target = this.get('changeParent') ? target.parentNode : target;
      data = this.context.getImageData(dims.left, dims.top, dims.width, dims.height).data;

      for (var p = 0; p < data.length; p += 4) {

        if (data[p] === mask.r && data[p + 1] === mask.g && data[p + 2] === mask.b) {
          minOverlap++;
        } else {
          pixels++;
          brightness = (0.2126 * data[p]) + (0.7152 * data[p + 1]) + (0.0722 * data[p + 2]);
          delta = brightness - mean;
          deltaSqr += delta * delta;
          mean = mean + delta / pixels;
        }
      }

      if (minOverlap <= (data.length / 4) * (1 - (this.get('minOverlap') / 100))) {
        variance = Math.sqrt(deltaSqr / pixels) / 255;
        mean = mean / 255;
        this.log('Target: ' + target.className +  ' lum: ' + mean + ' var: ' + variance);
        this.classList(target, mean <= (this.get('threshold') / 100) ? this.get('classes').dark : this.get('classes').light, 'add');

        if (variance > this.get('minComplexity') / 100) {
          this.classList(target, this.get('classes').complex, 'add');
        }
      }
    }
  }


  /*
   * Test if a is within b's boundary
   */
  isInside(a, b) {
    a = (a.nodeType ? a : a.el).getBoundingClientRect();
    b = b === this.viewport ? b : (b.nodeType ? b : b.el).getBoundingClientRect();

    return !(a.right < b.left || a.left > b.right || a.top > b.bottom || a.bottom < b.top);
  }


  /*
   * Process all targets (checkTarget is undefined)
   * or a single target (checkTarget is a previously set target)
   *
   * When not all images are loaded, checkTarget is an image
   * to avoid processing all targets multiple times
   */
  processTargets(checkTarget) {
    var start = new Date().getTime();
    var mode = (checkTarget && (checkTarget.tagName === 'IMG' || checkTarget.img)) ? 'image' : 'targets';
    var found = checkTarget ? false : true;
    var total = this.get('targets').length;
    var target;

    for (var t = 0; t < total; t++) {
      target = this.get('targets')[t];

      if (this.isInside(target, this.viewport)) {
        if (mode === 'targets' && (!checkTarget || checkTarget === target)) {
          found = true;
          this.calculatePixelBrightness(target);
        } else if (mode === 'image' && this.isInside(target, checkTarget)) {
          this.calculatePixelBrightness(target);
        }
      }
    }

    if (mode === 'targets' && !found) {
      throw checkTarget + ' is not a target';
    }

    this.kill(start);
  }


  /*
   * Find the element's zIndex. Also checks
   * the zIndex of its parent
   */
  getZIndex(el) {
    var calculate = (el)=>{
      var zindex = 0;

      if (window.getComputedStyle(el).position !== 'static') {
        zindex = parseInt(window.getComputedStyle(el).zIndex, 10) || 0;

        // Reserve zindex = 0 for elements with position: static;
        if (zindex >= 0) {
          zindex++;
        }
      }

      return zindex;
    };

    var parent = el.parentNode;
    var zIndexParent = parent ? calculate(parent) : 0;
    var zIndexEl = calculate(el);

    return (zIndexParent * 100000) + zIndexEl;
  }


  /*
   * Check zIndexes
   */
  sortImagesByZIndex(images) {
    var sorted = false;

    images.sort((a, b)=>{
      a = a.nodeType ? a : a.el;
      b = b.nodeType ? b : b.el;

      var pos = a.compareDocumentPosition(b);
      var reverse = 0;

      a = this.getZIndex(a);
      b = this.getZIndex(b);

      if (a > b) {
        sorted = true;
      }

      // Reposition if zIndex is the same but the elements are not
      // sorted according to their document position
      if (a === b && pos === 2) {
        reverse = 1;
      } else if (a === b && pos === 4) {
        reverse = -1;
      }

      return reverse || a - b;
    });

    this.log('Sorted: ' + sorted);

    if (sorted) {
      this.log(images);
    }

    return sorted;
  }


  /*
   * Main function
   */
  check(target, avoidClear, imageLoaded) {

    if (this.supported) {
      var mask = this.get('mask');

      this.log('--- BackgroundCheck ---');
      this.log('onLoad event: ' + (imageLoaded && imageLoaded.src));

      if (avoidClear !== true) {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.fillStyle = 'rgb(' + mask.r + ', ' + mask.g + ', ' + mask.b + ')';
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
      }

      var processImages = imageLoaded ? [imageLoaded] : this.get('images');
      var sorted = this.sortImagesByZIndex(processImages);
//console.log(processImages)
      var image;
      var imageNode;
      var loading = false;


      for (var i = 0; i < processImages.length; i++) {
        image = processImages[i];	
				image.crossOrigin = 'anonymous';			
//console.log(image)
        if (this.isInside(image, this.viewport)) {
					//console.log(image.src)
          imageNode = image.nodeType ? image : image.img;

					imageNode = document.createElement("img");
					imageNode.src = image.src;
					imageNode.crossOrigin = 'anonymous';	
					
					let _imageNode = imageNode;
					let _image = image;

					imageNode.onload = (e)=>{
            //console.log(_imageNode.src)

						//console.log(_image.naturalWidth)
						// console.log('Drawing: ' + _imageNode.src);
            this.drawImage(_image);
						this.processTargets(_image);
					}
        }
					

          // if (imageNode.naturalWidth === 0) {
          //   loading = true;
          //   this.log('Loading... ' + image.src);

					// 	var img = document.createElement("img");
					// 	img.src = image.src;
					// 	img.crossOrigin = 'anonymous';			

          //   img.removeEventListener('load', this.check);

          //   // if (sorted) {
          //   //   // Sorted -- redraw all images
          //   //   imageNode.addEventListener('load', this.check(null, false, null));
          //   // } else {
          //   //   // Not sorted -- just draw one image
          //   //   imageNode.addEventListener('load', this.check(target, true, image));
          //   // }
					// 	//imageNode.addEventListener('load', this.check(target, true, imageNode));
          // } else {
          //   this.log('Drawing: ' + image.src);
          //   this.drawImage(image);
          // }
        //}
      }

      // if (!imageLoaded && !loading) {
      //   this.processTargets(target);
      // } else if (imageLoaded) {
      //   this.processTargets(imageLoaded);
      // }
    }
  }


  /*
   * Throttle events
   */
  throttle(callback) {

    if (this.get('windowEvents') === true) {

      if (this.throttleDelay) {
        clearTimeout(this.throttleDelay);
      }

      this.throttleDelay = setTimeout(callback, 200);
    }
  }


  /*
   * Setter
   */
  set(property, newValue) {

    if (this.attrs[property] === undefined) {
      throw 'Unknown property - ' + property;
    } else if (newValue === undefined) {
      throw 'Missing value for ' + property;
    }

    if (property === 'targets' || property === 'images') {

      try {
        newValue = this.getElements(property === 'images' && !newValue ? 'img' : newValue, property === 'images' ? true : false);
      } catch (err) {
        newValue = [];
        throw err;
      }
    } else {
      this.checkType(newValue, typeof this.attrs[property]);
    }

    this.removeClasses();
    this.attrs[property] = newValue;
    this.check();

    if (property === 'debugOverlay') {
      this.showDebugOverlay();
    }
  }


  /*
   * Getter
   */
  get(property) {

    if (this.attrs[property] === undefined) {
      throw 'Unknown property - ' + property;
    }

    return this.attrs[property];
  }


  /*
   * Get position and size of all images.
   * Used for testing purposes
   */
  getImageData() {
    var images = this.get('images');
    var area;
    var data = [];

    for (var i = 0; i < images.length; i++) {
      area = this.getArea(images[i]);
      data.push(area);
    }

    return data;
  }


}


const getParams = (key = null)=>{
  const queryString = window.location.search;
  if(key){
    const urlParams = new URLSearchParams(queryString);
    const value = urlParams.get(key);
    return value;
  }

  return queryString;
  
} 

const addParams = (params)=>{
  let queryString = window.location.search;

  let ary = [];
  if(queryString){
    queryString = queryString.replace('?', '');
    ary = queryString.split('&');
  }
  
  
  let queryAry = {};
  for(let i = 0; i < ary.length; i++){
    let paramAry = ary[i].split('=');
    queryAry[paramAry[0]] = paramAry[1];
  }

  for (const property in params) {
    queryAry[property] = params[property];
  };

  let newQueryAry = [];
  //console.log('fuga');

  for (const property in queryAry) {
    newQueryAry.push(property + '=' + queryAry[property]);
  };

  //console.log(newQueryAry)

  let paramString = newQueryAry.join('&');

  paramString = '?' + paramString;

  //console.log(paramString)

  return paramString;

  // for(let i = 0; i < params.length; i++){

  // }
  // for(let i = 0; i < ary.length; i++){
  //   ary[i]
  // }
}


class trafficControl {
	supportPushState;
	historyLog = [];
  onUpdateCallBack = null;

  constructor (options = {}) {
    this.supportPushState = window.history && window.history.pushState ? true : false;
    if(this.supportPushState){
      history.replaceState({page: 'index'}, '', location.href);
      this.bindEvent();
      if(options.onUpdateCallBack){
        this.onUpdateCallBack = options.onUpdateCallBack;
      }
    }
  }

  bindEvent(){

    $(window).on('popstate', (e)=>{
    
      if(e.originalEvent){
        var state = e.originalEvent.state;
        console.log(state)
        if(state){
          //this.updateContents(state);
          this.onUpdateCallBack();
        }
        this.onUpdateCallBack();
      }
    }).on('updateState', (e)=>{
      //alert('test')
      console.log('updateState')
      if(e.obj){
        var state = history.state;
        if(state){
          this.updateContents(state);
          this.onUpdateCallBack();
        }
      }
    });	
  }  

  updateState(params, unused, url){
    console.log(url)
    history.replaceState(params, unused, url);
    // $(window).trigger({
    //   type: 'updateState',
    //   obj: params
    // });
  }
 

  updateContents(state){
    console.log('e: ' + state.page);
    this.historyLog.push(state.page);
    // var logL = _self.historyLog.length;
    // updateContents(location.href);
  }  

}

const mediaQuery = ()=>{
  window.matchMedia || (window.matchMedia = function() {
    "use strict";
  
    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = (window.styleMedia || window.media);
  
    // For those that don't support matchMedium
    if (!styleMedia) {
        var style       = document.createElement('style'),
            script      = document.getElementsByTagName('script')[0],
            info        = null;
  
        style.type  = 'text/css';
        style.id    = 'matchmediajs-test';
  
        if (!script) {
          document.head.appendChild(style);
        } else {
          script.parentNode.insertBefore(style, script);
        }
  
        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;
  
        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';
  
                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) {
                    style.styleSheet.cssText = text;
                } else {
                    style.textContent = text;
                }
  
                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }
  
    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
  }());
}


const scrollTo = ({ element = window, to, duration = 1000, easing = 'easeOutExpo' }) => {
  const startPosition = element === window ? window.pageYOffset : element.scrollTop;
  const distance = to - startPosition;
  let startTime = null;

  // Easing functions
  const easingFunctions = {
    linear: (t) => t,
    easeOutExpo: (t) => t === 1 ? 1 : 1 - Math.pow(2, -10 * t),
    easeInOutQuad: (t) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
  };

  // Animation loop
  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const progress = Math.min(timeElapsed / duration, 1);
    const easingFunction = easingFunctions[easing] || easingFunctions['linear'];
    const easedProgress = easingFunction(progress);
    
    if (element === window) {
      window.scrollTo(0, startPosition + distance * easedProgress);
    } else {
      element.scrollTop = startPosition + distance * easedProgress;
    }

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    }
  }

  requestAnimationFrame(animation);
};



export {
  mediaQuery,
  scrollTo,
  //lockBG
}